import { defineComponent as _defineComponent } from 'vue'
import { watch, ref } from 'vue';
import { chipsBoxProps, chipsBoxEmits } from './chipsBox';
import { UPDATE_MODEL_VALUE } from '../../constants';
import spaceFormat from '../../utils/spaceFormat';
import { UiIconClose } from '../../icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'chipsBox',
  props: chipsBoxProps,
  emits: chipsBoxEmits,
  setup(__props, { emit: emits }) {

const props = __props




const chips = ref<string[]>([]);

const handleClickClose = (chip: string, index: number): void => {
    chips.value.splice(index, 1);
    emits(UPDATE_MODEL_VALUE, chips.value);
    emits('close', { chip, index });
};

const handleExcessClose = (excessIndex: number): void => {
    const fullIndex = (props.max ?? 0) + excessIndex;
    const chip = chips.value[fullIndex];
    chips.value.splice(fullIndex, 1);
    emits(UPDATE_MODEL_VALUE, chips.value);
    emits('close', { chip, index: fullIndex });
};

watch(() => props.modelValue, (value: string[]) => chips.value = value, { immediate: true });

return { __sfc: true,props, emits, chips, handleClickClose, handleExcessClose, spaceFormat, UiIconClose }
}

})